module.exports = __webpack_public_path__ + "img/public/siteImages/shareIcon.svg?74d38422";